import { Component, EventEmitter, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { SelectBrandItem } from '../../../../../services/dashboard.service';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { SortDirection, SortState } from '../../../../../utils/sort-state';
import { CCDEvent, CCDEventType } from '../../types/types';
import { IHeaderParams } from 'ag-grid-community';
import { AssetVersionPipe } from '../../../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-header-cell',
  imports: [
    NgClass,
    AssetVersionPipe
  ],
  templateUrl: './header-cell.component.html',
  styleUrl: './header-cell.component.scss'
})
export class HeaderCellComponent implements IHeaderAngularComp {
  @Input({ required: true }) brand!: SelectBrandItem;
  @Input({ required: true }) events!: EventEmitter<CCDEvent>;
  @Input() defaultSort: SortDirection = SortDirection.default;
  @Input() isMyBrand: boolean = false;

  protected sort = new SortState();
  private params: IHeaderParams | undefined;

  agInit(params: any): void {
    this.setParams(params);
    this.sort = new SortState(this.defaultSort);

    this.events = params.events;
    this.events.subscribe((event: CCDEvent) => {
      switch (event.type) {
        case CCDEventType.SORT:
          if (event.sortDirection === SortDirection.default && this.isMyBrand) {
            this.sort.seSortDirection(SortDirection.desc);
          } else if (event.colId !== this.brand.key) {
            this.sort.change(true);
          }
          break;
      }

    })
  }

  refresh(params: any): boolean {
    this.setParams(params);
    return false;
  }

  protected onClick(event: MouseEvent): void {
    if (this.isMyBrand) {
      const nextSortDirection = this.sort.direction === SortDirection.asc ? SortDirection.desc : SortDirection.asc;
      this.sort.seSortDirection(nextSortDirection);
    } else {
      this.sort.change(false);
    }
    const nextSort = this.sort.direction === SortDirection.default ? null : this.sort.direction;
    this.params?.setSort(nextSort);
    this.events.emit({
      type: CCDEventType.SORT,
      colId: this.brand.key,
      sortDirection: this.sort.direction
    });
  }

  protected onIconError(event: Event): void {
    (event.target as HTMLImageElement).src = 'images/no-logo.png';
  }

  protected onImgError(event: ErrorEvent) {
    (event.target as HTMLImageElement).style.display = 'none';
  }

  private setParams(params: any): void {
    this.params = params;
    this.brand = params.brand;
    this.isMyBrand = params.isMyBrand;
    this.defaultSort = params.defaultSort;
  }

}
